"use client";

import { useTheme } from 'next-themes';
import React from 'react';

interface VirecLogoProps {
  className?: string;
  size?: number | string;
  lightModeColor?: string;
  darkModeColor?: string;
}

export default function VirecLogo({ 
  className = '', 
  size = 30,
  lightModeColor = 'var(--foreground)',
  darkModeColor = 'var(--foreground)'
}: VirecLogoProps) {
  const { theme, systemTheme } = useTheme();
  
  // Determine if we should use dark mode
  const isDarkMode = theme === 'dark' || (theme === 'system' && systemTheme === 'dark');
  const color = isDarkMode ? darkModeColor : lightModeColor;

  return (
    <svg 
      className={className}
      width={size}
      version="1.0" 
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600.000000 116.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g 
        transform="translate(0.000000,116.000000) scale(0.100000,-0.100000)"
        fill={color} 
        stroke="none"
      >
        <path d="M2 1151 c2 -5 97 -266 213 -580 l209 -571 108 0 c59 0 108 4 108 9 0
27 -301 848 -417 1139 -6 14 -227 18 -221 3z"/>
        <path d="M776 850 l-128 -310 47 -122 c26 -68 50 -129 54 -135 5 -10 343 798
359 860 4 15 -6 17 -100 17 l-105 0 -127 -310z"/>
        <path d="M1710 580 l0 -580 100 0 100 0 0 580 0 580 -100 0 -100 0 0 -580z"/>
        <path d="M5585 1144 c-173 -34 -342 -158 -411 -301 -143 -297 -31 -635 257
-773 119 -57 192 -70 397 -70 l172 0 0 90 0 90 -132 0 c-73 0 -164 5 -203 10
-137 20 -237 89 -298 205 -31 58 -32 65 -32 180 0 116 1 123 33 187 56 115
167 190 306 208 39 5 128 10 199 10 l127 0 0 90 0 90 -172 -1 c-103 0 -201 -6
-243 -15z"/>
        <path d="M2570 1061 l0 -90 298 -3 c285 -3 299 -4 339 -25 80 -43 114 -118 94
-209 -13 -55 -48 -97 -111 -130 -31 -17 -65 -19 -327 -22 l-293 -3 0 -290 0
-289 100 0 100 0 0 200 0 200 129 0 128 0 138 -196 c76 -108 144 -198 150
-200 6 -3 61 -3 122 -2 l110 3 -154 214 c-85 117 -153 215 -151 216 2 1 31 15
65 30 130 58 203 174 203 325 0 178 -96 298 -275 345 -47 12 -122 15 -362 15
l-303 0 0 -89z"/>
        <path d="M3870 1060 l0 -90 435 0 435 0 0 90 0 90 -435 0 -435 0 0 -90z"/>
        <path d="M3870 580 l0 -90 388 0 c214 0 391 2 393 4 2 2 3 43 1 90 l-3 86
-390 0 -389 0 0 -90z"/>
        <path d="M3870 90 l0 -90 435 0 435 0 0 90 0 90 -435 0 -435 0 0 -90z"/>
      </g>
    </svg>
  );
}
